import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Contingentes } from '../../../../models/contingentes';
import { ClaseContingenteService } from '../../../../services/clase-contingente.service';
import {MyValidations} from '../../../../utils/my-validations';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-contingentes-detalle',
  templateUrl: './contingentes-detalle.component.html',
  styleUrls: ['./contingentes-detalle.component.css']
})
export class ContingentesDetalleComponent implements OnInit, AfterViewInit {
  
  constructor(private fb: FormBuilder, 
              private claseContingenteService: ClaseContingenteService) { }

  @Input() set contingente(contingenteRecibida: Contingentes)
  {
    this.contingenteForm = contingenteRecibida;
    this.setearForm(contingenteRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;
  @Input() anteriorRetroactividad: boolean;
  @Input() grupoLiq: any;
  @Input() contingentesInvalida: boolean;

  form: FormGroup;
  contingenteForm: Contingentes;
  actualizarFormatoInputNumerico = false;
  submitted: boolean;
  formHabilitado: boolean;
  claseContingenteList: any;
  MensajeRetro = "";

  ngOnInit(): void
  {
    this.configurarValidadores();
    
    this.claseContingenteService.getAll().subscribe(docs => { this.claseContingenteList = docs })

    this.setearForm(this.contingenteForm);
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      claseContingente: ['', Validators.required],
      cantidad: ['', Validators.required],
      inicioLiquidacion: ['', [Validators.required, , MyValidations.fecHastaMenor]],
      finLiquidacion: ['', [Validators.required, MyValidations.fecHastaMenor4]],
      cantidadConsumida: ['']
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(contingente: Contingentes)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(contingente?.id);
      this.form.controls['desde'].setValue(new Date(contingente?.desde));
      this.form.controls['hasta'].setValue(new Date(contingente?.hasta));
      this.form.controls['personal'].setValue(contingente?.personal);
      this.form.controls['claseContingente'].setValue(contingente?.claseContingente);
      this.form.controls['cantidad'].setValue(contingente?.cantidad);
      if (contingente?.inicioLiquidacion != null) {
        this.form.controls['inicioLiquidacion'].setValue(new Date(contingente?.inicioLiquidacion));
      }
      if (contingente?.finLiquidacion != null) {
        this.form.controls['finLiquidacion'].setValue(new Date(contingente?.finLiquidacion));
      }
      
      if (contingente.id == 0)
      {
        this.form.controls['cantidadConsumida'].setValue(0);
        this.habilitarForm(true);
      }
      else
      {
        this.form.controls['cantidadConsumida'].setValue(contingente?.diasConsumidos);
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
      this.formHabilitado = habilitado;
      this.form.controls['cantidadConsumida'].disable();
    }
  }

  ngAfterViewInit()
  {
    if (this.form.controls['id'].value != "0")
    {
    }
  }

  setValidatorRequired(campo, requerido) {
    this.form.controls[campo].setValidators(requerido);
    this.form.controls[campo].updateValueAndValidity();
  }

  onChangeFechas()
  {
  }

  
}

